import type { ReactNode } from 'react';
import clsx from 'clsx';
import { WizardStep } from './WizardStep';
import { Button } from '../../';

export const WizardStepper: React.FC<{
    stages: string[];
    currentStep: number;
    onNext: () => void;
    onPrev: () => void;
    children: ReactNode;
    showNavigationButtons?: boolean;
}> = ({ stages, currentStep, onNext, onPrev, children, showNavigationButtons = false }) => {
    return (
        <div>
            <div className="isolate overflow-x-auto scroll-smooth snap-x snap-mandatory">
                <div className="flex w-full space-x-0">
                    {stages.map((label, index) => (
                        <WizardStep
                            key={label}
                            label={label}
                            isActive={index === currentStep}
                            isComplete={index < currentStep}
                            isFirst={index === 0}
                            isLast={index === stages.length - 1}
                            className={clsx(index !== 0 && '-ml-7', 'snap-start shrink-0')}
                            zIndex={100 - index} // ensure later steps appear on top
                        />
                    ))}
                </div>
            </div>
            {children}
            {showNavigationButtons && (
                <div className="flex justify-between mt-4">
                    <Button onClick={onPrev} disabled={currentStep === 0}>
                        Previous
                    </Button>
                    <Button onClick={onNext} disabled={currentStep === stages.length - 1}>
                        Next
                    </Button>
                </div>
            )}
        </div>
    );
};
